import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { Match } from '../../_shared/models/match.model';
import { DownloadMatchService } from './download-match.service';
@Component({
  standalone: false,
    selector: 'app-download-match',
    templateUrl: './download-match.component.html',
    styleUrls: ['./download-match.component.scss'],
})
export class DownloadMatchComponent implements OnDestroy {
    @Input() match: Match;

    private destroyed$: Subject<void> = new Subject();
    isLoading: boolean;


    constructor(
        private downloadMatchService: DownloadMatchService,
        private socket: Socket
    ) { }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    downloadMatch() {
        this.isLoading = true;

        this.downloadMatchService
            .downloadMatch(this.match, this.match.source.partner)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                }),
                takeUntil(this.destroyed$)
            )
            .subscribe(
                res => {
                    this.downloadMatchService.publishFollow(res.data);
                    // this.socket.emit('add-tournament-match', { tournamentId: this.match.tournament, matchUp: res.data });
                }
            );

    }
}
